import { render, staticRenderFns } from "./loader-min.vue?vue&type=template&id=333be612&scoped=true&"
var script = {}
import style0 from "./loader-min.vue?vue&type=style&index=0&id=333be612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333be612",
  null
  
)

export default component.exports